import parseContentStore from "../data/content-store.js";
import { isExternalUrl } from "../navigation/navigation-utils.js";

export default function initContentRenderer() {
  console.log("INIT Content Renderer RUNNING");
  const items = parseContentStore();

  renderAlerts(items);
  //renderImportant(items);
  initNewsControls();
  renderCTA(items);
  enhanceCTA();
}

function renderAlerts(items) {
  const alertItems = items.filter((i) => i.category.includes("alert"));

  const button = document.querySelector(".sz-utility-bell");
  if (!button) return;

  const countEl = button.querySelector(".sz-utility-bell__count");
  const tooltip = button.querySelector(".sz-utility-bell__tooltip");
  const icon = button.querySelector(".sz-utility-bell__icon");

  const count = alertItems.length;

  // ✅ STATE UPDATE
  if (count > 0) {
    button.dataset.alertState = "active";

    if (countEl) {
      countEl.textContent = count;
      countEl.hidden = false;
    }

    if (tooltip) {
      tooltip.textContent = count === 1 ? "1 alert" : `${count} alerts`;
    }

    if (icon) {
      icon.classList.remove("bi-bell-slash");
      icon.classList.add("bi-bell-fill");
    }

    // ✅ animation
    if (!window.__alertTimersInitialised) {
      window.__alertTimersInitialised = true;

      const triggerBell = () => {
        button.classList.add("is-animating");

        setTimeout(() => {
          button.classList.remove("is-animating");
        }, 1200);
      };

      setTimeout(() => {
        triggerBell();
        setInterval(triggerBell, 30000);
      }, 10000);
    }
  } else {
    button.dataset.alertState = "empty";

    if (countEl) countEl.hidden = true;

    if (tooltip) {
      tooltip.textContent = "No alerts at present";
    }

    if (icon) {
      icon.classList.remove("bi-bell-fill");
      icon.classList.add("bi-bell-slash");
    }
  }

  // Accessibility
  button.setAttribute(
    "aria-label",
    count > 0 ? `${count} student alerts` : "No student alerts",
  );

  // Modal
  const modalEl = document.getElementById("alertsModal");

  if (modalEl && window.bootstrap && bootstrap.Modal) {
    const modal = new bootstrap.Modal(modalEl);

    button.onclick = () => {
      if (count > 0) {
        const modalBody = document.getElementById("sz-alert-modal-body");

        if (modalBody) {
          modalBody.innerHTML = alertItems
            .map((alert) => {
              const url = alert.url || "";
              const isExternal = isExternalUrl(url);

              const title = url
                ? `
        <a href="${url}"${isExternal ? ' class="is-external"' : ""}>
          <strong>
            ${alert.title}
            ${isExternal ? externalLinkIndicator() : ""}
          </strong>
        </a>
      `
                : `<strong>${alert.title}</strong>`;

              return `
      <div class="alert alert-info">
        ${title}
        <p class="mb-0">${alert.message}</p>
      </div>
    `;
            })
            .join("");
        }

        modal.show();
      }
    };
  } else {
    button.onclick = () => {
      if (count > 0) {
        console.log("Modal not available");
      }
    };
  }

  button.dataset.alertReady = "true";
}

function stripHTML(html) {
  if (!html) return "";

  const div = document.createElement("div");
  div.innerHTML = html;
  return div.textContent || div.innerText || "";
}

function externalLinkIndicator() {
  return `
    <span class="sz-link-external-icon" aria-hidden="true">
      <i class="bi bi-box-arrow-up-right"></i>
    </span>
    <span class="visually-hidden"> external link</span>
  `;
}

function externalClass(url) {
  return isExternalUrl(url) ? " is-external" : "";
}

function externalLabel(url) {
  return isExternalUrl(url) ? externalLinkIndicator() : "";
}

function initNewsControls() {
  console.log("INIT News Controls RUNNING");
  const list = document.querySelector(".sz-news__list");
  if (!list) return;

  const viewport = list.closest(".sz-news__viewport");
  if (!viewport) return;

  const prev = viewport.querySelector(".sz-news__control--prev");
  const next = viewport.querySelector(".sz-news__control--next");

  if (!prev || !next) return;

  const isDesktopLike = window.matchMedia(
    "(hover: hover) and (pointer: fine)",
  ).matches;
  const isGrid = window.matchMedia("(min-width: 768px)").matches;

  // Hide controls if not needed
  if (!isDesktopLike || isGrid) {
    prev.hidden = true;
    next.hidden = true;
    return;
  }

  const updateControls = () => {
    const maxScroll = list.scrollWidth - list.clientWidth;
    const hasOverflow = maxScroll > 8;

    prev.hidden = !hasOverflow || list.scrollLeft <= 8;
    next.hidden = !hasOverflow || list.scrollLeft >= maxScroll - 8;
  };

  const getScrollAmount = () => {
    const firstCard = list.querySelector(".sz-card");
    if (!firstCard) return 300;

    const styles = window.getComputedStyle(list);
    const gap = parseFloat(styles.columnGap || styles.gap || "0");

    return firstCard.getBoundingClientRect().width + gap;
  };

  prev.addEventListener("click", () => {
    list.scrollBy({ left: -getScrollAmount(), behavior: "smooth" });
  });

  next.addEventListener("click", () => {
    list.scrollBy({ left: getScrollAmount(), behavior: "smooth" });
  });

  list.addEventListener("scroll", updateControls, { passive: true });
  window.addEventListener("resize", updateControls);

  updateControls();
}

function renderCTA(items) {
  const container = document.querySelector('[data-module="promos"]');
  if (!container) return;

  const ctas = items.filter((i) => i.category.includes("cta")).slice(0, 2);

  if (!ctas.length) {
    container.remove();
    return;
  }

  container.innerHTML = `
    <ul class="sz-promo-list">
      ${ctas
        .map((item) => {
          const url = item.url || "#";
          const isExternal = isExternalUrl(url);

          return `
          <li class="sz-promo-list__item">
            <a href="${url}" class="sz-promo${isExternal ? " is-external" : ""}">

              ${
                item.image
                  ? `
                <div class="sz-promo__image">
                  <img src="${item.image}" alt="${item.title || ""}">
                </div>
              `
                  : ""
              }

              <div class="sz-promo__content">
                <strong>
                  ${item.title}
                  ${isExternal ? externalLinkIndicator() : ""}
                </strong>
                ${item.message ? `<p>${stripHTML(item.message)}</p>` : ""}
              </div>

            </a>
          </li>
        `;
        })
        .join("")}
    </ul>
  `;
}

function enhanceCTA() {
  const container = document.querySelector('[data-module="promos"]');
  if (!container) return;

  container.classList.add("is-ready");
}
/* function enhanceCTA() {
  const container = document.querySelector('[data-module="promos"]');
  if (!container) return;

  const items = Array.from(container.children);

  if (items.length > 2) {
    const shuffled = items.sort(() => Math.random() - 0.5);

    shuffled.forEach((el, i) => {
      el.style.display = i < 2 ? "" : "none";
    });
  }

  container.classList.add("is-ready");
} */
